import { Stack } from "@mui/material";
import { ReactNode } from "react";
import { GuideButton } from "./GuideButton.tsx";

/** The header of a page, with the button of the page's guide at its end. */
export const GuideHeader = ({ children }: { children: ReactNode }) => (
  <Stack
    direction="row"
    spacing={2}
    useFlexGap
    sx={{
      alignItems: "flex-end",
      justifyContent: "space-between",
      flexWrap: "wrap",
    }}
  >
    {children}
    <GuideButton />
  </Stack>
);
